import { useController, useFormContext } from 'react-hook-form';
import { MobileInputType } from '@/common/components/base/input/mobileInput/MobileInput.type.ts';
import { MOBILE_NUMBER_RULE } from '@/common/components/base/input/mobileInput/mobileInput.rules.ts';
import handlersMiddleware from '@/common/components/base/input/base/helpers/handlersMiddleware.ts';
import removeFirstCharacter from '@/common/components/base/input/mobileInput/changeHandlers/removeFirstCharacter.ts';
import inputChunkSeparator from '@/common/components/base/input/mobileInput/changeHandlers/inputChunkSeparator.ts';
import { ChangeEventHandler } from 'react';
import { digitsArToEn } from '@persian-tools/persian-tools';
import removeAllNoneNumbers from '@/common/components/base/input/base/changeHandlers/removeAllNoneNumbers.ts';
import limitValueLength from '@/common/components/base/input/base/changeHandlers/limitValueLength.ts';
import addZeroAtFirst from '@/common/components/base/input/mobileInput/changeHandlers/addZeroAtFirst.ts';
import Input from '@/common/components/base/input/base/Input.tsx';
import formResetAttachment from '@/common/components/base/input/base/attachments/FormResetAttachment.tsx';
import mobileLabelAttachment from '@/common/components/base/input/mobileInput/attachments/MobileLabelAttachment.tsx';
import removeZeroAtFirst from '@/common/components/base/input/base/changeHandlers/removeZeroAtFirst';
import { convertToEnglishDigits } from '@/common/components/base/input/base/changeHandlers/convertToEnglishDigits';

const MobileInput = ({
  disabled = false,
  label,
  onChange,
  name,
  rules,
  defaultValue = '0',
  required = true,
  optionalLabel,
}: MobileInputType) => {
  const { control } = useFormContext();
  const controller = useController({
    rules: { ...MOBILE_NUMBER_RULE({ required: required }), ...rules },
    name,
    control,
    defaultValue,
  });
  const { field, fieldState } = controller;
  const errorMessage = fieldState.error?.message;

  // Add null check before applying handlers
  const fieldValue = field.value
    ? handlersMiddleware(field.value, [
        removeFirstCharacter,
        inputChunkSeparator,
      ])
    : '';

  const inputOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    // Add null check for e.target.value
    const inputValue = e.target.value || '';
    const value = handlersMiddleware(inputValue, [
      convertToEnglishDigits,
      removeZeroAtFirst,
      digitsArToEn,
      removeAllNoneNumbers,
      limitValueLength(10),
      addZeroAtFirst,
    ]);
    field.onChange(value);
    onChange?.(value);
  };

  const onReset = () => {
    field.onChange('');
    onChange?.('');
  };

  return (
    <Input
      inputProps={{
        value: fieldValue,
        onChange: inputOnChange,
        placeholder: 'XXX - XXX - XXXX',
        disabled,
        type: 'tel',
      }}
      optionalLabel={optionalLabel}
      direction="ltr"
      inputRef={field.ref}
      errorMessage={errorMessage}
      label={label ?? 'تلفن همراه'}
      endAttachments={[
        formResetAttachment({
          onReset,
          renderCondition: !!Number(field.value) && !disabled,
        }),
      ]}
      startAttachments={[mobileLabelAttachment]}
    />
  );
};
export default MobileInput;
